import gql from 'graphql-tag';

export const UPDATE_STAGE_FIELDS = gql`
  mutation UpdateStageFields($input: UpdateStageFieldsInput!) {
    bpf {
      updateStageFields(input: $input) {
        error
        entity
        success
      }
    }
  }
`;
